import React from 'react';
import moment from 'moment';

const EventWrapper = ({ event, children }) => {
    const start = moment(event.start);
    const end = moment(event.end);

    const hourStart = start.hour();
    const hourEnd = end.hour();

    const offsetStart = Math.floor( start.minutes() / 15 )
    const offsetEnd = Math.floor( end.minutes() / 15 ) - offsetStart;

    return (
        <div
            title={event.title}
            className={`${children.props.className} rbc-event`}
            style={{ gridRow: `${(hourStart * 4) + offsetStart + 1 } / span ${((hourEnd - hourStart) * 4) + offsetEnd }` }}
            onClick={event.selectAction}
        >
            {children.props.children}
        </div>
    );
};

export default EventWrapper;
